import React, { useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";

import { MUISelect } from "../MUISelect";
import { normalize } from "../../helpers/normalize";
import { useNetwork } from "../../hooks/useNetwork";

export const L2Selector = ({
  isDisabled = false,
  onSelectHandler,
  defaultValue = 0,
  extraMenuOptions = [],
  filter = (x) => true,
  resetDeps = [],
  fullWidth = false,
}) => {
  const [value, setValue] = React.useState("");
  const { getL2Options, selectedNetwork } = useNetwork();

  let l2Options = getL2Options(selectedNetwork.l1Id)
    .filter((x) => filter(x))
    .map((x) => ({ id: x.l2Id, name: x.l2Name }));

  if (extraMenuOptions.length > 0) {
    l2Options = l2Options.concat(extraMenuOptions);
  }

  useEffect(() => {
    onSelectHandler(null);
    setValue("");
  }, [selectedNetwork.l1Id, normalize(resetDeps)]);

  const handleChange = (e) => {
    setValue(e.target.value);
    onSelectHandler(e.target.value);
  };

  useEffect(() => {
    if (!defaultValue) return;
    setValue(String(defaultValue));
    onSelectHandler(String(defaultValue));
  }, [defaultValue]);

  return (
    <MUISelect value={value} label="Matching Round" id="subnetwork-select" onChange={handleChange} disabled={isDisabled} fullWidth={fullWidth}>
      {!l2Options.length && <MenuItem disabled>{selectedNetwork.l1Id ? "Empty" : "Please select network"}</MenuItem>}
      {l2Options.map((l2) => (
        <MenuItem value={l2.id} key={l2.id}>
          {l2.name}
        </MenuItem>
      ))}
    </MUISelect>
  );
};

export const L3Selector = ({ onSelectHandler, l2Selection, isDisabled = false, defaultValue = 0, fullWidth = false }) => {
  const [value, setValue] = React.useState("");
  const { selectedNetwork, getL3Options } = useNetwork();

  const l3Options = l2Selection
    ? getL3Options(selectedNetwork.l1Id, l2Selection).map((x) => ({
        id: x.l3Id,
        name: x.name,
      }))
    : [];

  useEffect(() => {
    setValue("");
    onSelectHandler(null);
  }, [selectedNetwork.l1Id, l2Selection]);

  useEffect(() => {
    if (!defaultValue || !l3Options.length) return;
    setValue(defaultValue);
    onSelectHandler(defaultValue);
  }, [defaultValue, normalize(l3Options)]);

  const handleChange = (e) => {
    setValue(e.target.value);
    onSelectHandler(e.target.value);
  };

  return (
    <MUISelect value={value} label="Unit Type" id="unit-type-select" onChange={handleChange} disabled={isDisabled} fullWidth={fullWidth}>
      {!l3Options.length && <MenuItem disabled>{l2Selection ? "Empty" : "Please select subnetwork"}</MenuItem>}
      {l3Options.map((l3) => (
        <MenuItem value={l3.id} key={l3.id}>
          {l3.name}
        </MenuItem>
      ))}
    </MUISelect>
  );
};

export const L4Selector = ({ onSelectHandler, l2Selection, l3Selection, isDisabled = false, defaultValue = 0, fullWidth = false }) => {
  const [value, setValue] = React.useState("");
  const { selectedNetwork, getL3 } = useNetwork();

  const l4Options = l2Selection
    ? getL3(selectedNetwork.l1Id, l2Selection, l3Selection).l4.map((x) => ({
        id: x.l4Id,
        name: x.name,
      }))
    : [];

  useEffect(() => {
    if (!defaultValue || !l4Options.length) return;
    setValue(defaultValue);
    onSelectHandler(defaultValue);
  }, [defaultValue, normalize(l4Options)]);

  const handleChange = (e) => {
    setValue(e.target.value);
    onSelectHandler(e.target.value);
  };

  return (
    <MUISelect value={value} label="Room Type" id="room-type-select" onChange={handleChange} disabled={isDisabled} fullWidth={fullWidth}>
      {!l4Options.length && <MenuItem disabled>{l2Selection ? "Empty" : "Please select unit type"}</MenuItem>}
      {l4Options.map((l4) => (
        <MenuItem value={l4.id} key={l4.id}>
          {l4.name}
        </MenuItem>
      ))}
    </MUISelect>
  );
};
